<template>
  <div class="c-loyalty">
    <img :src="image" alt="Loyalty" class="c-loyalty__icon" />
    <div class="c-loyalty__text">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OLoyaltyPoints',
  props: {
    image: String
  }
}
</script>

<style lang="scss">
.c-loyalty {
  background: rgba($primary-color, 0.1);
  background: var(--primary-color-light);
  border-radius: 0.4rem;
  align-items: center;
  display: inline-flex;
  font-size: 1.4rem;
  line-height: 2rem;
  min-width: 16rem;
  padding: 0.8rem;
}

.c-loyalty__icon {
  display: block;
  width: 4rem;
  heigth: auto;
  margin: 0 0.8rem 0 0 !important;
}
</style>
